import script from "./KidsRides.vue?vue&type=script&setup=true&lang=js"
export * from "./KidsRides.vue?vue&type=script&setup=true&lang=js"

import "./KidsRides.vue?vue&type=style&index=0&id=5f07d7ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f07d7ec"]])

export default __exports__